module.exports = __webpack_public_path__ + "static/media/bg_CrossHotel.a689bd16.jpg";